<div class="p-6">

  <div class="flex flex-wrap items-center justify-between gap-4">
    <h1 class="font-bold text-3xl">Applications</h1>
    <p-button
      label="Reapply to all failed lotteries"
      icon="pi pi-refresh"
      (onClick)="retryFailedApplications()"
      [loading]="isRetryingFailedApplications()"
      [disabled]="isRetryingFailedApplications()"
      class="p-button-sm"
    ></p-button>
  </div>

  @let applications = applications$ | async;

  <h2 class="font-medium text-2xl">Failed applications</h2>
  @if (applications) {
    <p-table [value]="applications">
      <ng-template pTemplate="header">
        <tr>
          <th>User ID</th>
          <th>Lottery</th>
          <th>Failure reason</th>
          <th>Created at</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-application [cTypedTableRow]="applications">
        <tr class="cursor-pointer" [routerLink]="['/users', application.userId]">
          <td>{{ application.userId }}</td>
          <td>{{ application.lotteryId }}</td>
          <td>{{ application.failureReason }}</td>
          <td>
            {{ application.createdAt | date: 'dd-MM-yyyy HH:mm:ss' }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>
